import React from "react";
import "./CreatedNoteBlock.css";

import { noteTemplate } from "../../Templates/noteTemplate";

interface noteBlockProps {
    id: string,
    noteInfo: noteTemplate,
    wasClicked: (noteInfo: noteTemplate, key: number) => void,
    keyOfTemplate: number
}

function CreatedNoteBlock(props: noteBlockProps): JSX.Element {
    return (
        <div className="createdNoteBlock" id={props.id} onClick={() => {props.wasClicked(props.noteInfo, props.keyOfTemplate)}}>
            <div className="createdNoteBlock_titleSection">
                <h5 className="titleOfCreatedNoteBlock">{props.noteInfo.Title}</h5>
            </div>

            <div className="createdNoteBlock_noteSection">
                <h5 className="contentOfCreatedNoteBlock">{props.noteInfo.Note}</h5>
            </div>

            <div className="createdNoteBlock_dateSection">
                <h5 className="dateOfCreatedNoteBlock">{props.noteInfo["Date Created"].toLocaleString()}</h5>
            </div>
        </div>
    )
}

export default CreatedNoteBlock;